import { useQuery } from '@tanstack/react-query'

import { FailureEnvelop, GetShortCategoryListViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

export const useGetCategories = () => {
    const { data, isLoading } = useQuery<GetShortCategoryListViewModel, FailureEnvelop>({
        queryKey: QueryKeys.Interactify.Categories,
        queryFn: () =>
            fetchRequest({
                endpoint: '/videos/short-video/categories',
                method: 'GET',
                serviceName: 'cml',
            }),
        staleTime: Infinity,
    })

    return { data: data?.categories || [], isLoading }
}
